<template>
	<div class="finance_box">
		<el-alert
			class="version-tip"
			type="info"
			:closable="false"
			:title="t('versionControl.tip')"
		/>
		<el-form v-loading="state.loading" ref="ruleForm" label-width="auto" :model="state.form" :rules="rules" class="userFrom">
				<el-form-item :label="t('versionControl.androidVersion')" prop="appVersion">
					<el-input v-model="state.form.appVersion" class="width-220" :placeholder="t('versionControl.versionInputPh')" />
				</el-form-item>
				<el-form-item :label="t('versionControl.iosVersion')" prop="iosVersion">
					<el-input v-model="state.form.iosVersion" class="width-220" :placeholder="t('versionControl.versionInputPh')" />
				</el-form-item>
                <el-form-item :label="t('versionControl.androidUrl')" prop="androidUrl">
					<el-input v-model="state.form.androidUrl" class="width-220" :placeholder="t('versionControl.androidUrlPh')" />
				</el-form-item>
				<el-form-item :label="t('versionControl.iosUrl')" prop="iosUrl">
					<el-input v-model="state.form.iosUrl" class="width-220" :placeholder="t('versionControl.iosUrlPh')" />
				</el-form-item>
				<el-form-item :label="t('versionControl.compulsorySwitch')" prop="compulsory">
					<el-switch v-model="state.form.compulsory" :active-value="1" :inactive-value="0" :active-text="t('common.yes')" :inactive-text="t('common.no')" />
				</el-form-item>
		</el-form>
		<div class="btn_box">
			<el-button @click="clearForm">{{ t('versionControl.clear') }}</el-button>
			<el-button type="primary" @click="submit">{{ t('common.save') }}</el-button>
		</div>
	</div>
</template>

<script setup>
import { onMounted, reactive, ref } from "vue";
import { ElMessage } from "element-plus";
import { getVersionInfo, saveVersionInfo } from "@/api/system/version";
import { usePageI18n } from '@/composables/usePageI18n.js';

const ruleForm = ref();

const state = reactive({
	loading: false,
	form: {
		appVersion: "",
		iosVersion: "",
		iosUrl: "",
		androidUrl: "",
		compulsory: 0,
	},
});

const rules = reactive({
	appVersion: [{ required: true, message: "", trigger: "blur" }],
	iosVersion: [{ required: true, message: "", trigger: "blur" }],
	iosUrl: [{ required: true, message: "", trigger: "blur" }],
	androidUrl: [{ required: true, message: "", trigger: "blur" }],
});

const applyLabels = () => {
	if (rules?.appVersion?.[0]) rules.appVersion[0].message = t('versionControl.versionInputPh');
	if (rules?.iosVersion?.[0]) rules.iosVersion[0].message = t('versionControl.needIosVersion');
	if (rules?.iosUrl?.[0]) rules.iosUrl[0].message = t('versionControl.needIosUrl');
	if (rules?.androidUrl?.[0]) rules.androidUrl[0].message = t('versionControl.needAndroidUrl');
};
const { t } = usePageI18n(applyLabels);

const getForm = () => {
	state.loading = true;
	getVersionInfo("{}")
		.then((res) => {
			if (res?.code === 200 && res?.data) {
				state.form.appVersion = res.data.appVersion ?? "";
				state.form.iosVersion = res.data.iosVersion ?? "";
				state.form.iosUrl = res.data.iosUrl ?? "";
				state.form.androidUrl = res.data.androidUrl ?? "";
				state.form.compulsory = res.data.compulsory ?? 0;
			}
		})
		.finally(() => {
			state.loading = false;
		});
};

const clearForm = () => {
	state.form = {
		appVersion: "",
		iosVersion: "",
		iosUrl: "",
		androidUrl: "",
		compulsory: 0,
	};
};

const submit = () => {
	ruleForm.value.validate((valid) => {
		if (valid) {
			const params = JSON.stringify({
				appVersion: state.form.appVersion,
				iosVersion: state.form.iosVersion,
				iosUrl: state.form.iosUrl,
				androidUrl: state.form.androidUrl,
				compulsory: state.form.compulsory,
			});
			saveVersionInfo(params).then((res) => {
				if (res?.code === 200) {
					ElMessage.success(t('common.success'));
					getForm();
				} else {
					ElMessage.error(res?.msg || t('common.failed'));
				}
			});
		}
	});
};

onMounted(() => {
	applyLabels();
	getForm();
});
</script>

<style lang="less" scoped>
.version-tip {
	width: 100%;
	max-width: 550px;
	margin-bottom: 16px;
}

.finance_box {
    width: 100%;
	overflow: auto;
	background-color: #fff;
	border-radius: 6px;
	padding: 10px;
	margin-right: 10px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.userFrom {
    width: 100%;
	display: flex;
    flex-direction: column;
    align-items: center;
	// gap: 20px;
	// grid-template-columns: repeat(2, 1fr);

    :deep(.el-form-item) {
        width: 550px;
    }
}

.width-220 {
	width: 420px;
}

.btn_box {
	display: flex;
	justify-content: center;
	margin-top: 40px;
}
</style>
